"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogMarkDownEditor = exports.markDownEditorDialogType = void 0;
const DialogBase_1 = require("./DialogBase");
exports.markDownEditorDialogType = 'MARKDOWN_EDITOR';
class DialogMarkDownEditor extends DialogBase_1.DialogBase {
    constructor(data) {
        super(exports.markDownEditorDialogType);
        this.type = exports.markDownEditorDialogType;
        this.cancel = () => {
            this.isOpen = false;
        };
        this.confirm = (text) => {
            this.isOpen = false;
            this.postConfirm(text);
        };
        this.initialText = data.initialText;
        this.postConfirm = data.onConfirm;
    }
}
exports.DialogMarkDownEditor = DialogMarkDownEditor;
